<template>
  <div class="bg-image-full">
    <b-container>
      <div class="form-container">
        <form action @submit.prevent="forgetPassword">
          <router-link to="/">
            <img :src="logo" class="mb-5 d-block mx-auto logo" alt />
          </router-link>

          <BaseSectionTitle :title="'Forget password'" :left="true" />
          <h6>We will send you a password reset link on registered email address.</h6>
          <div class="contact-form mt-5">
            <BaseInput
              :label="'Email address'"
              v-model="email"
              v-validate="'required|email'"
              name="email"
            >
              <slot>
                <span class="error">{{errors.first('email')}}</span>
              </slot>
            </BaseInput>

            <!-- <span class="error mb-5" v-if="loginFailed">These credentials do not match our records.</span> -->
            <BaseButton :label="'Get link'" />
            <!-- <small class="text-center w-100 d-inline-block mt-2">
              <a href class="medium opacity-5">Forgot password ?</a>
            </small>-->
            <small class="text-center w-100 d-inline-block mt-5">
              Don't have an account ?
              <router-link to="/register" class="link semibold">Register</router-link>
            </small>
          </div>
        </form>
      </div>
    </b-container>
  </div>
</template>

<script>
import api from "@/api.js";
import BaseInput from "@/components/ui/Elements/BaseInput";
import BaseButton from "@/components/ui/Elements/BaseButton";
import auth from "@/auth.js";
export default {
  components: {
    BaseInput,
    BaseButton
  },
  data() {
    return {
      email: ""
    };
  },
  computed: {
    logo() {
      return this.$store.state.logo;
    }
  },
  methods: {
    makeToast(append = false) {
      this.$bvToast.toast(`Please check your email id.`, {
        toaster: "b-toaster-top-center",
        title: this.errorMessage,
        autoHideDelay: 5000,
        appendToast: append,
        variant: "danger"
      });
    },
    forgetPassword() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.axios
            .post(`${api.url}/forgot-password`, {
              email: this.email
            })
            .then(response => {
              this.errorMessage = response.data.message;
              if (response.data.success === "1") {
                this.$bvToast.toast(`Check your email address.`, {
                  toaster: "b-toaster-top-center",
                  title: "Password reset link has been sent.",
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "success"
                });
              } else {
                this.$bvToast.toast(`Please check your email id.`, {
                  toaster: "b-toaster-top-center",
                  title: this.errorMessage,
                  autoHideDelay: 5000,
                  appendToast: false,
                  variant: "danger"
                });
              }
            });
        } else {
          alert("failed");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  @include for-size(mobile) {
    padding: 0px;
  }
}

.logo {
  max-width: 200px;
  max-height: 60px;
  object-fit: contain;
}

.bg-image-full {
  @include flex-row-center;
  height: 100vh;
  width: 100vw;
  background: url("../../../assets/images/fleet-blur-hero.jpg");
}

.form-container {
  max-width: 500px;
  margin: 0 auto;
  background: rgba(249, 249, 251, 0.95);
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 25px;
  padding-bottom: 30px;
  width: 100%;
  border-radius: 4px;
  @include for-size(mobile) {
    border-radius: 0px;
    height: 100vh;
    background: white;
  }
}

.link {
  border-bottom: 1px solid #00cc37;
}

.semibold {
  font-weight: 600;
}
</style>
    